import { normalizeBogglePlaygroundSettings } from '~/boggle/lib/playground'

export const RACE_CORE_PRESET = normalizeBogglePlaygroundSettings({
  allowDiagonals: true,
  extraLetterBonusTime: 0,
  gridSize: '4x3',
  intervalCount: 1,
  intervalTimeSeconds: 80,
  letterAdjacencyMode: 'free',
  lettersRepopulate: true,
  tileSpawnIntervalMs: 100,
  meter: {
    enabled: true,
    capacity: 80,
    segments: [{ scoreBonus: 0, size: 1 }],
    tileSpawn: {
      baseIntervalSeconds: 3,
      enabled: true,
      powerExponent: 0.74,
      tileKind: 'gold',
    },
    bursts: [
      {
        id: 'gold-rush',
        trigger: 'timer-end',
        drain: {
          drainRampSeconds: 2,
          durationSeconds: 9,
        },
        effects: ['virtual-gold', 'pause-tile-spawn', 'replace-interval-timer'],
        enabled: true,
      },
    ],
    increase: {
      acceptedWord: {
        base: 0,
        letterOffset: -2,
        lengthBands: [
          { base: 0, letterOffset: -2, maxLength: 3, minLength: 3, perLetter: 1 },
          { base: 0, letterOffset: -3, maxLength: 4, minLength: 4, perLetter: 3 },
          { base: 0, letterOffset: -4, maxLength: 5, minLength: 5, perLetter: 5 },
          { base: 0, letterOffset: -4, maxLength: null, minLength: 6, perLetter: 4 },
        ],
        perLetter: 1,
        uncommonLetter: {
          perOccurrence: 1,
        },
        rareLetter: {
          perOccurrence: 2,
        },
        repeatScalar: 0, // No bonus for repeats
      },
    },
    naturalDecayPerSecond: 0,
  },
  minWordLength: 3,
  redrawBoardAfterWord: false,
  rotationEnabled: false,
  scoreBonusMaxLength: 5,
  scoreMode: 'per-cleared-tile',
  specialTiles: {
    gold: {
      countAtStart: 0,
      enabled: true,
      maximumCount: 1,
      replaceWhenCleared: false,
      spawnEveryXTiles: null,
    },
  },
  skills: {
    copy: { enabled: false, uses: null },
    reset: { delaySeconds: 2, enabled: false, uses: null },
    shuffle: { enabled: false, uses: null },
    swap: { enabled: false, uses: null },
    zap: { enabled: false, uses: null },
  },
})

export const RACE_HARD_CORE_PRESET = normalizeBogglePlaygroundSettings(
  {
    allowRepeats: false,
    minWordLength: 4,
  },
  RACE_CORE_PRESET,
)
